module.exports = "<div class=\"site-container\" [ngClass]=\"{'rtl': rtl}\" [attr.dir]=\"rtl ? 'rtl' : null\">\n  <main class=\"main-content\">\n    <div class=\"main-content-wrapper\">\n      <app-landing-page-navbar></app-landing-page-navbar>\n      <router-outlet></router-outlet>\n      <app-landing-page-footer></app-landing-page-footer>\n    </div>\n  </main>\n  <!--<div class=\"backdrop\"></div>-->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/landing-page/landing-page.component.html
// module id = ./src/app/home/pages/landing-page/landing-page.component.html
// module chunks = main